<template>
  <div ref="container" style="padding-top:8px;">
    <vonap-toolbar-label label="Report Date">
      <input id="periodControl" style="width: 125px;" />
    </vonap-toolbar-label>
    <vonap-toolbar-label v-show="clientId == 0" label="Analyst">
      <analyst-email v-model="analystEmail" @change="analystEmailChanged" />
    </vonap-toolbar-label>
    <vonap-toolbar-label v-show="clientId == 0" label="Responsible">
      <responsible-email v-model="responsibleEmail" @change="responsibleEmailChanged" />
    </vonap-toolbar-label>
    <vonap-toolbar-label v-show="showForwardOption" label="Forwards or options">
      <kendo-dropdownlist
        title="Option"
        id="optionDropDownList"
        :data-source="optionDataSource"
        :data-text-field="'forwardOptionName'"
        :data-value-field="'forwardOptionId'"
        :change="optionDropDownChange"
        style="width: 125px;"
      >
      </kendo-dropdownlist>
    </vonap-toolbar-label>
    <vonap-toolbar-label label="Reconciled Client">
      <kendo-dropdownlist
        :data-source="reconciledClientDataSource"
        :data-text-field="'text'"
        :data-value-field="'value'"
        :change="reconciledClientChange"
        style="width: 132px;"
      >
      </kendo-dropdownlist>
    </vonap-toolbar-label>
    <slot v-bind:toolbar="toolbar">
      <kendo-button type="button" @click="onExport" icon="excel" title="Export to Excel" />
    </slot>
  </div>
</template>

<script>
const $ = kendo.jQuery
import {mapGetters} from 'vuex'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
import AnalystEmail from '@/components/AnalystEmail'
import ResponsibleEmail from '@/components/ResponsibleEmail'

export default {
  components: {
    VonapToolbarLabel,
    AnalystEmail,
    ResponsibleEmail,
  },
  props: {
    marketId: {type: Number, required: true},
    showForwardOption: {type: Boolean, default: true},
    refreshKey: {type: Number, default: 14},
  },
  data() {
    return {
      toolbar,
      analystEmail: 'ALL',
      responsibleEmail: 'ALL',
      reconciledClient: 0,
      reconciledClientDataSource: [
        {text: 'All', value: 0},
        {text: 'Reconciled', value: 1},
        {text: 'Not Reconciled', value: 2},
      ],
      optionValue: 0,
      optionDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/report/ExposureReport/getForwardOption',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  methods: {
    analystEmailChanged() {
      this.$emit('change', toolbar.getSelectedValues())
    },
    responsibleEmailChanged() {
      this.$emit('change', toolbar.getSelectedValues())
    },
    reconciledClientChange({sender}) {
      this.reconciledClient = +sender.value()
      this.$emit('change', toolbar.getSelectedValues())
    },
    optionDropDownChange({sender}) {
      this.optionValue = +sender.value()
      this.$emit('change', toolbar.getSelectedValues())
    },
    onExport() {
      this.$emit('export', toolbar.getSelectedValues())
    },
  },
  async mounted() {
    await toolbar.createToolbar(this)
    this.$emit('change', toolbar.getSelectedValues())
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
  },
  watch: {
    refreshKey: function() {
      this.$emit('change', toolbar.getSelectedValues())
    },
  },
}

const toolbar = (() => {
  'use strict'
  let period
  let vm

  function createExposureToolbar() {
    return new Promise(function(resolve) {
      resolve()
      return
    }).then(function() {
      return new Promise(function(toolbarResolve) {
        period = $('#periodControl')
          .kendoDatePicker({
            format: 'yyyy-MM-dd',
            value: kendo.parseDate(localStorage.getItem('reportDate')) || new Date(),
            change: async e => {
              localStorage.setItem('reportDate', kendo.toString(e.sender.value(), 'yyyy-MM-dd'))
              vm.$emit('change', getSelectedValues())
            },
          })
          .getKendoDatePicker()
        toolbarResolve()
      })
    })
  }

  function getSelectedValues() {
    return {
      clientId: vm.clientId,
      asOfDate: kendo.toString(period.value(), 'yyyy-MM-dd'),
      analystEmail: vm.analystEmail,
      responsibleEmail: vm.responsibleEmail,
      marketId: vm.marketId,
      optionValue: vm.optionValue,
      reconciledClient: vm.reconciledClient,
    }
  }

  return {
    createToolbar($vm) {
      vm = $vm
      return createExposureToolbar()
    },
    getSelectedValues: getSelectedValues,
  }
})()
</script>
